export default {
  default: {
    title: "CONTACTSECTION.contactTitle",
    text1: "CONTACTSECTION.contactEmailUs",
    text2: "CONTACTSECTION.contactEmail",
    icon: require("../../../../images/email.png"),
    link: "mailto:hello@disinfection2u.co.id",
  },
};
